import { PaymentCardType } from '@mews-commander/data-access';
import { enumify, Enumify } from '@mews/enumify';

function CreditCardType() {}

enumify<PaymentCardType, number>(CreditCardType, 'CreditCardType', {
    MasterCard: 1,
    Visa: 2,
    Amex: 3,
    Discover: 4,
    DinersClub: 5,
    Jcb: 6,
    Maestro: 8,
    UnionPay: 9,
    VPay: 10,
    RuPay: 11,
    Dankort: 12,
    Mir: 13,
    Verve: 14,
    Troy: 15,
    PostFinance: 16,
    Giro: 17,
    Bancomat: 18,
    Bc: 19,
    CarteBleue: 20,
    Eftpos: 21,
    Eps: 22,
    Interac: 23,
    Isracard: 24,
    Meps: 25,
    Nets: 26,
    Bancontact: 27,
});

export default CreditCardType as unknown as Enumify<PaymentCardType, number>;
